import React, { useEffect, useRef } from "react";
import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  createStyledIndicatorButton,
  IndicatorIcon,
} from "../../../common/StyledComponents/SideBarComponents";
import aIbadgeIcon from "../../../assets/images/chats/aIbadgeIcon.svg";
import AILoder from "../AI/AILoder";

const cfg = {
  colors: {
    primary: "#F3F3F3",
    secondary: "#e8ebed",
    accent: "pink-600",

    // Typing & Loading
    typingCursor: "#9333ea",
    typingIndicator: "#9ca3af",

    // Timestamp
    timestamp: "#9ca3af",
    white: "white",
    black: "black",
  },
};
function ChatBot({ messages, loading }) {
  const BadgeButton = createStyledIndicatorButton("#F3F3F3");

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    setTimeout(scrollToBottom, 50);
  }, [messages]);

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {/* Messages Container */}
      <Box
        flex={1}
        overflow="auto"
        sx={{
          background: cfg.colors.white,
        }}
      >
        <Stack spacing={1.5}>
          {messages.map((message, index) => (
            <React.Fragment
              key={message.timestamp || index}>
             {message?.query && (
                <Box key={index} display="flex" justifyContent={"flex-end"}>
                  <Box
                    display="flex"
                    flexDirection={"row-reverse"}
                    // alignItems="flex-end"
                    gap={1}
                    maxWidth={{ xs: "85%", md: "75%" }}
                  >
                    <Box>
                      <BadgeButton size="small" variant="contained">
                        <Typography
                          variant="subtitle2"
                          fontSize={"0.87rem"}
                          color={"#183242"}
                          fontWeight={600}
                        >
                          Q
                        </Typography>
                      </BadgeButton>
                    </Box>

                    <Box>
                      {/* Bubble */}
                      <Box
                        sx={{
                          px: 2,
                          py: 1.25,
                          borderRadius: 2,
                          borderTopLeftRadius:  16,
                          borderBottomRightRadius:  4,
                          background: cfg.colors.primary,
                          color: cfg.colors.black,
                        }}
                      >
                        <Typography
                          fontSize={14}
                          lineHeight={1.6}
                          whiteSpace="pre-wrap"
                        >
                          {message.query}
                        </Typography>
                      </Box>

                      {/* Timestamp */}
                      <Typography
                        fontSize={11}
                        mt={0.5}
                        px={0.5}
                        textAlign={"right"}
                        sx={{ color: cfg.colors.timestamp }}
                      >
                        12:05pm
                        {/* {message.timestamp.toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })} */}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
              {message?.response && (
                <Box
                  key={index}
                  display="flex"
                  justifyContent={"flex-start"}
                >
                  <Box
                    display="flex"
                    flexDirection={"row"}
                    // alignItems="flex-end"
                    gap={1}
                    maxWidth={{ xs: "85%", md: "75%" }}
                  >
                    <BadgeButton size="small" variant="contained">
                        <IndicatorIcon src={aIbadgeIcon} />
                      </BadgeButton>

                    <Box>
                      {/* Bubble */}
                      <Box
                          sx={{
                            px: 2,
                            py: 1.25,
                            borderRadius: 2,
                            borderTopLeftRadius:  4 ,
                            borderBottomRightRadius: 16 ,
                            background: cfg.colors.primary,
                            color: cfg.colors.black,
                          }}
                        >
                          <Typography
                            fontSize={14}
                            lineHeight={1.6}
                            whiteSpace="pre-wrap"
                          >
                            {message.response}
                          </Typography>
                        </Box>
                      {/* Timestamp */}
                      <Typography
                        fontSize={11}
                        mt={0.5}
                        px={0.5}
                        textAlign={"left"}
                        sx={{ color: cfg.colors.timestamp }}
                      >
                        {/* {message.timestamp.toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })} */}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
             
            </React.Fragment>
          ))}

          {/* Typing Indicator */}
          {loading && (
            <Box display="flex" justifyContent="flex-start">
              <AILoder/>
            </Box>
          )}

          <div ref={messagesEndRef} />
        </Stack>
      </Box>
    </Box>
  );
}

export default ChatBot;


